<template>
  <!-- 轮播条展示 -->
  <div class="order-user_bar" :class="{ common: hasLimit }" v-if="useBar && userIndex > 0">
    <template v-for="(user, index) in orderUserList">
      <div
        class="animate__animated"
        :key="index"
        v-if="isUserIndex(user, index)"
        :class="animateAction"
      >
        <span class="head">
          <img :src="user.avtarUrl" alt="">
        </span>
        <!-- {{ userIndex }}, {{ index }} -->
        <span class="text nickname">{{ getNickname(user) }}</span>
        <!-- <span class="text" v-if="hasLimit">已获得{{ user.couponAmount }}元抵扣权益</span> -->
        <!-- <span class="text" v-else>已升级为无限卡会员</span> -->
        <span class="text">已购买</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'order-userbar',
  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      user: { id: 0 },
      userIndex: 0,
      timeCount: 60, // 轮询1分钟
      animateAction: 'animate__fadeInUp'
    }
  },
  computed: {
    ...mapGetters('goods/vip', [
      'orderUserList',
      // 限购规则
      'limitData'
    ]),

    // 是无限卡购买（VIP商品 & 权益类型无限）
    isVipForever() {
      return this.options && (this.options.isVipForever || this.options.isVipForeverIncrease)
    },
    goodsIds() {
      return this.options && this.options.goodsIds
    },
    useBar() {
      return this.hasLimit || this.isVipForever || this.options.isVipForeverIncrease
    },
    hasLimit() {
      const { hasLimit } = this.limitData || {}
      return hasLimit
    }
  },
  watch: {
    // 订单弹幕气泡动画（通用商品页，商品ID已查询完成）
    useBar(val) {
      if (val) {
        this.getGoodsBuyInfo()
      }
    },
    // 传入的商品ID
    'goodsIds.length'(val, oldVal) {
      if (val) {
        this.getGoodsBuyInfo(this.goodsIds)
      }
    }
  },
  activated() {
    this.timeGo(this.orderUserList)
  },
  deactivated() {
    this.timeStop()
  },
  methods: {
    getNickname(user) {
      const { nickname = '' } = user
      return nickname.substr(0, 2) + '**'
    },
    isUserIndex(user, index) {
      const list = this.orderUserList
      const len = list.length
      let n = (this.userIndex) % len
      n = (n === 0 ? len : n) - 1
      return n === index
    },
    getGoodsBuyInfo(goodsIds) {
      console.log('goodsIds---------', goodsIds)
      if (goodsIds == null) {
        goodsIds = this.limitData.limitGoodsIdList
      }
      const orderCount = this.timeCount
      // 没有商品时跳过
      if (goodsIds.length === 0) {
        return
      }
      // // 临时看无限卡轮播效果
      // const url = window.location.href
      // if (url.indexOf('test') >= 0 || url.indexOf('localhost')) {
      //   goodsIds = goodsIds.concat([98776])
      // }
      const getGoodsBuyInfo = this.hasLimit ? 'getGoodsBuyInfo' : 'getCommonGoodsBuyInfo'
      // const getGoodsBuyInfo = 'getCommonGoodsBuyInfo'
      this.$store.dispatch('goods/vip/' + getGoodsBuyInfo, { goodsIds, orderCount }).then(
        this.timeGo
      )
    },
    // 循环1分钟
    timeGo(list) {
      const vm = this
      if (list.length === 0) return
      // 1s 切换已购用户信息
      vm.userIndex = 1
      const count = this.timeCount

      if (vm.time) {
        clearInterval(vm.time)
      }
      vm.time = setInterval(() => {
        // console.log('UserBar> userIndex', vm.userIndex)
        // console.log('UserBar> count', count)
        if (vm.userIndex < count) {
          vm.userIndex++
          // console.log('getGoodsBuyInfo', vm.userIndex)
        } else {
          // 重新开始计时
          clearInterval(vm.time)
          vm.userIndex = 1
          this.getGoodsBuyInfo()
          // console.log('getGoodsBuyInfo', vm.time)
        }
      }, 1500)
    },
    timeStop() {
      if (this.time) {
        clearInterval(this.time)
        this.time = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-user_bar {
  background: #00000066;
  border-radius: 0 3rem 3rem 0;
  width: max-content;
  min-width: 3.5rem;
  position: fixed;
  bottom: 2.86rem;
  padding: 0.1rem 0.2rem;
  overflow: hidden;
  opacity: 0.8;
  &.common {
    min-width: 3rem;
  }
  .head {
    margin-right: 0.2rem;
    vertical-align: middle;
    display: inline-block;
    img {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 0.3rem;
    }
  }
  .text {
    color: #FFFFFF;
    font-size: 0.25rem;
    &.nickname {
      margin-right: 0.25rem;
    }
  }
}
</style>
